import { createFileRoute } from "@tanstack/react-router";

import CreateCampaignForm from "@/components/organisms/campaigns/CreateCampaignForm";

const CreateCampaign = () => {
  return <CreateCampaignForm />;
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/campaign/create")({
  component: CreateCampaign,
});
